import { setLanguage as setI18n } from '../localization'

const Language = {
  SET_LANGUAGE: 'SET_LANGUAGE',
}

export function setLanguage(language) {
  return {
    type: Language.SET_LANGUAGE,
    language,
  }
}

function getInitialState() {
  let language = localStorage.getItem('language') || 'en'
  setI18n(language)
  return language
}

const language = (state = getInitialState(), action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return action.language
    default:
      return state
  }
}

export default language
